module.exports = __webpack_public_path__ + "static/assets/ea2761877653a984f009e7d575315d5f.svg";